import { useLocation, useNavigate, useParams, type NavigateOptions, type To } from "react-router-dom";
import { useMemo } from "react";

export function useRouter() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const router = useMemo(() => {
        return {
            push: (to: To, options?: NavigateOptions) => navigate(to, options),
            replace: (to: To, options?: NavigateOptions) => navigate(to, { ...options, replace: true }),
            back: (value?: number) => navigate(value || -1),
            forward: () => navigate(1),
            pathname: location.pathname,
            params,
        };
    }, [location, params, navigate])

    return router;
}